/* import __COLOCATED_TEMPLATE__ from './classification-attributes-step.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    stepNumber: string | number;
    title: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const ClassificationAttributesStep = templateOnlyComponent<Signature>();
export default ClassificationAttributesStep;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Components::ClassificationAttributesStep': typeof ClassificationAttributesStep;
  }
}
